export const SIGNATURE_TEXT_MAX_CHARS = 1200;

/** Keep the top of the signature; drop trailing legal disclaimers. */
export function tailTruncateSignature(text, maxChars = SIGNATURE_TEXT_MAX_CHARS) {
  const raw = String(text || '');
  if (raw.length <= maxChars) return raw.trim();
  return raw.slice(0, maxChars).trim();
}

/**
 * Create-contact drawer deep link from signature box content only.
 * Returns null without a tenant instance so we never send users to another workspace.
 */
export function buildCreateContactFromSignatureUrl(instance, text) {
  if (!instance) return null;
  const signature = tailTruncateSignature(text);
  if (!signature) return null;

  const params = new URLSearchParams();
  params.set('createContact', '1');
  params.set('signature', signature);
  return `https://${instance}.assistgo.de/contacts?${params.toString()}`;
}
